import React from "react";

import { observer } from "mobx-react";

import { Bet } from "@models";

import { useTranslation } from "react-i18next";

export const GainBonusPercentage = observer(
	function GainBonusPercentage(props: { bet: Bet }) {
		const { t } = useTranslation("mybets");

		const { bet } = props;

		if (!bet.gainBonus && !bet.gainBonusPercentage) {
			return null;
		}
		return (
			<div className="bet__details__row">
				<div className="bet__details__col">
					{t("ITEM.ADDITIONAL_GAIN_BONUS", {
						0: bet.gainBonusPercentage.toFixed(),
					})}
				</div>
				<div className="bet__details__col">{bet.displayGainBonus}</div>
			</div>
		);
	}
);
